import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PRODUCTS, EXTRA_PRODUCTS } from "@/lib/api";

export const Products = () => {
  return (
    <section id="products" className="py-24 md:py-32 bg-oed-surface border-y border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-oed-gold mb-6">The Product Line</p>
            <h2 className="font-display font-bold tracking-tight text-4xl md:text-5xl leading-[1.05] max-w-2xl">
              Premium products people actually want.
            </h2>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {PRODUCTS.map((p, i) => (
            <motion.article
              key={p.key}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: (i % 2) * 0.1 }}
              data-testid={`product-card-${p.key}`}
              className="group bg-oed-base p-6 md:p-8"
            >
              <Link to={`/products/${p.key}`} className="block">
                <div className="relative overflow-hidden aspect-[4/3]">
                  <img
                    src={p.img}
                    alt={p.title}
                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/0 transition-colors duration-500" />
                  <span className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.25em] bg-black/50 backdrop-blur px-3 py-1.5 text-white/80">
                    {p.tag}
                  </span>
                </div>
                <div className="mt-6 flex items-start justify-between gap-4">
                  <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight group-hover:text-oed-gold transition-colors">{p.title}</h3>
                  <ArrowUpRight size={22} className="mt-1 shrink-0 text-white/40 group-hover:text-oed-gold group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
                </div>
                <p className="mt-3 text-sm text-white/50 leading-relaxed max-w-md">{p.desc}</p>
                <span className="mt-5 inline-block text-xs uppercase tracking-[0.2em] text-oed-gold">View details →</span>
              </Link>
            </motion.article>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          {EXTRA_PRODUCTS.map((e) => (
            <span key={e} className="border border-white/15 px-5 py-2.5 text-sm text-white/60 hover:border-oed-gold hover:text-white transition-colors">
              {e}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
